export default __webpack_public_path__ + "static/ProductDesign-2710a0f324f1b37799e4bdacba958305.png";